import { render, staticRenderFns } from "./Detallticket.vue?vue&type=template&id=7fdc0356"
import script from "./Detallticket.vue?vue&type=script&lang=js"
export * from "./Detallticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports